import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import LoginView from '../views/Login.vue'
import DocumentsView from '../views/Documents.vue'
import CompliancesView from '../views/Compliances.vue'
import SecurityCategoriesView from '../views/SecurityCategories.vue'
import UpdatesView from '../views/Updates.vue'
import UsersView from '../views/Users.vue'
import YourTenantsView from '../views/Dashboard.vue' // Your Tenants component
import NotFoundView from '../views/NotFound.vue' // Create this new component
import SettingsView from '../views/Settings.vue'
import VulnerabilitiesView from '../views/Vulnerabilities.vue'
import ProductsView from '../views/Products.vue'
import AuditLogsView from '../views/AuditLogs.vue'
import CRADashboardView from '../views/CRADashboard.vue'
import NIS2DashboardView from '../views/NIS2Dashboard.vue'
import ENISAReportingView from '../views/ENISAReporting.vue'
import IncidentsView from '../views/Incidents.vue'
import DocumentAccessView from '../views/DocumentAccess.vue'
import VulnReportsView from '../views/VulnReports.vue'
import SubscribersView from '../views/Subscribers.vue'
import CustomerAccessView from '../views/CustomerAccess.vue'
import ServiceAccountsView from '../views/ServiceAccounts.vue'
import WebhooksView from '../views/Webhooks.vue'
import PortfolioView from '../views/Portfolio.vue'
import DORADashboardView from '../views/DORADashboard.vue'
import EO14028DashboardView from '../views/EO14028Dashboard.vue'
import ForgotPasswordView from '../views/ForgotPassword.vue'

const routes = [
  {
    path: '/',
    name: 'YourTenants',
    component: YourTenantsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/login/:token',
    name: 'LoginToken',
    component: LoginView
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ForgotPasswordView
  },
  {
    path: '/tenants/:tenantId/documents',
    name: 'Documents',
    component: DocumentsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/compliances',
    name: 'Compliances',
    component: CompliancesView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/security-categories',
    name: 'SecurityCategories',
    component: SecurityCategoriesView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/updates',
    name: 'Updates',
    component: UpdatesView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/users',
    name: 'Users',
    component: UsersView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/settings',
    name: 'Settings',
    component: SettingsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/vulnerabilities',
    name: 'Vulnerabilities',
    component: VulnerabilitiesView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/products',
    name: 'Products',
    component: ProductsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/portfolio',
    name: 'Portfolio',
    component: PortfolioView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/portfolio/:tab',
    name: 'PortfolioTab',
    component: PortfolioView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/cra-readiness',
    name: 'CRADashboard',
    component: CRADashboardView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/nis2-readiness',
    name: 'NIS2Dashboard',
    component: NIS2DashboardView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/enisa-reporting',
    name: 'ENISAReporting',
    component: ENISAReportingView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/incidents',
    name: 'Incidents',
    component: IncidentsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/document-access',
    name: 'DocumentAccess',
    component: DocumentAccessView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/vuln-reports',
    name: 'VulnReports',
    component: VulnReportsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/subscribers',
    name: 'Subscribers',
    component: SubscribersView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/customer-access',
    name: 'CustomerAccess',
    component: CustomerAccessView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/service-accounts',
    name: 'ServiceAccounts',
    component: ServiceAccountsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/webhooks',
    name: 'Webhooks',
    component: WebhooksView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/dora-readiness',
    name: 'DORADashboard',
    component: DORADashboardView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/eo14028-readiness',
    name: 'EO14028Dashboard',
    component: EO14028DashboardView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/tenants/:tenantId/audit-logs',
    name: 'AuditLogs',
    component: AuditLogsView,
    meta: { requiresAuth: true, requiresTenant: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next('/login')
    } else if (to.matched.some(record => record.meta.requiresTenant)) {
      const urlTenantId = to.params.tenantId
      const storedTenantId = store.getters.currentTenantId

      // If there's a tenant ID in the URL, use it and update storage
      if (urlTenantId) {
        // Verify the tenant exists and user has access
        try {
          await store.dispatch('fetchTenants')
          const tenantExists = store.state.tenants.some(t => t.tenant_id === urlTenantId)
          if (tenantExists) {
            store.dispatch('setCurrentTenant', urlTenantId)
            next()
          } else {
            // If tenant doesn't exist or user doesn't have access, redirect to dashboard
            store.dispatch('setCurrentTenant', null)
            next('/')
          }
        } catch (error) {
          console.error('Error verifying tenant:', error)
          next('/')
        }
      } else if (storedTenantId) {
        // If no tenant in URL but we have one stored, redirect to that tenant's route
        next(`/tenants/${storedTenantId}${to.path === '/' ? '/documents' : ''}`)
      } else {
        // No tenant selected, go to dashboard
        next('/')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router